import { ChevronIcon } from '@p2p/assets/svg';
import { PaymentType } from '@p2p/shared/constants';
import { getPaymentAmount, isCardPaymentLinkOrder } from '@p2p/shared/functions';
import classNames from 'classnames';

import { Timer } from '../Timer';
import styles from './TransferHead.module.scss';
import { TransferHeadProps } from './TransferHead.types';

export const TransferHead = ({
  time,
  order,
  toggleMode,
  open,
  setOpen,
  isFail = false,
}: TransferHeadProps) => {
  const show = (toggleMode && open) || !toggleMode;
  // P2P-2915: оплата картой по ссылке провайдера (SimplePay ecom). Реквизит у
  // такой заявки технический (C2C-заглушка), «Оплата по номеру карты» ввело бы
  // в заблуждение — по макету сверху блок «Быстрая оплата» с суммой.
  const isCardPaymentLink = isCardPaymentLinkOrder(order);
  // P2P-2851 (корректировка ТЗ 30.10.2026): у QR, который оплачивают в валюте
  // провайдера (MeridianPay, индонезийский QRIS), плательщик переводит не
  // рублёвую сумму заявки, а присланную провайдером сумму в своей валюте —
  // показываем её и её код вместо прежней пары «сумма заявки + RUB». У всех
  // остальных заявок getPaymentAmount отдаёт то же, что было раньше.
  // 02.11.2026: под ней - рублёвая сумма заявки (orderAmount), просьба бизнеса.
  const { amount, currency, orderAmount } = getPaymentAmount(order);

  return (
    <div className={styles.transfer_dialog__header}>
      <div
        className={classNames(styles.transfer_dialog__header_info, {
          [styles.horizontalPadding]: toggleMode !== undefined,
          [styles.headerContainer]: toggleMode !== undefined,
          [styles.close]: !open && toggleMode,
        })}
        onClick={() => setOpen?.(!open)}
      >
        <div
          className={classNames(styles.transfer_dialog__header_title, {
            [styles.smMobileTitle]: [
              PaymentType.PAYMENT_TYPE_TRANSFER,
              PaymentType.PAYMENT_TYPE_C2C,
            ].includes(order?.requisite.payment_type as PaymentType),
          })}
        >
          {isCardPaymentLink && 'Быстрая оплата'}
          {!isCardPaymentLink &&
            order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_SBP &&
            'Оплата через СБП'}
          {!isCardPaymentLink &&
            order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_C2C &&
            'Оплата по номеру карты'}
          {!isCardPaymentLink &&
            order?.requisite.payment_type === PaymentType.PAYMENT_TYPE_TRANSFER &&
            'Оплата по номеру счета'}
        </div>

        {toggleMode && !isFail ? (
          <div
            onClick={() => setOpen?.(!open)}
            className={classNames(styles.chevron, { [styles.open]: open })}
          >
            <ChevronIcon />
          </div>
        ) : (
          <Timer time={time} />
        )}
      </div>

      {(show || isFail) && (
        <div
          className={classNames(styles.transfer_dialog__header_amount, {
            [styles.horizontalPadding]: toggleMode !== undefined,
          })}
        >
          {amount}
          <span>{currency}</span>
        </div>
      )}

      {(show || isFail) && orderAmount && (
        <div
          className={classNames(styles.transfer_dialog__header_order_amount, {
            [styles.horizontalPadding]: toggleMode !== undefined,
          })}
        >
          {orderAmount.amount} {orderAmount.currency}
        </div>
      )}
    </div>
  );
};
